const getMusic = (scene) => {
  if (!window.credits_score) {
    window.credits_score = scene.sound.add("credits", {
      loop: true,
      valume: 0,
    });
  }
  return window.credits_score;
};
export const playGlobalScore = (scene) => {
  stopResumeScore(scene);
  const music = getMusic(scene);
  if (!music.isPlaying) {
    music.play();
    music.volume = 0;

    scene.tweens.add({
      targets: music,
      volume: 1,
      delay: 10,
      ease: "Linear",
      duration: 1000,
    });
  }
};
export const stopGlobalScore = (scene) => {
  const music = getMusic(scene);
  if (music.isPlaying) {
    scene.tweens.add({
      targets: music,
      volume: 0,
      ease: "Linear",
      duration: 1000,
      onComplete: () => {
        music.stop();
      },
    });
  }
};

const getResumeMusic = (scene) => {
  if (!window.resume_score) {
    window.resume_score = scene.sound.add("generic_chat_music", {
      loop: true,
      valume: 0,
    });
  }
  return window.resume_score;
};
export const playResumeScore = (scene) => {
  const music = getResumeMusic(scene);
  if (!music.isPlaying) {
    music.play();
    music.volume = 0;

    scene.tweens.add({
      targets: music,
      volume: 1,
      delay: 10,
      ease: "Linear",
      duration: 1000,
    });
  }
};
export const stopResumeScore = (scene) => {
  const music = getResumeMusic(scene);
  if (music.isPlaying) {
    scene.tweens.add({
      targets: music,
      volume: 0,
      ease: "Linear",
      duration: 1000,
      onComplete: () => {
        music.stop();
      },
    });
  }
};
